<!-- 孩子基础信息 孩子神启 -->
<template>
  <div class="TableContent TableContents_2">
    <p class="setctionTitle">基础信息</p>
    <ul class="DataListStyle clear">
      <li class="li_k1">名字：</li>
      <li class="li1">{{ child.name }}</li>
      <li class="li_k1">等级：</li>
      <li class="li1">{{ child.lv }}</li>
      <li class="li_k1">经验：</li>
      <li class="li1">{{ child.exp }}</li>
    </ul>
    <ul class="DataListStyle clear">
      <li class="li_k3 margin1">生命：</li>
      <li class="li3 margin1">{{ child_effect['mhp'] }}</li>
      <li class="li_k2 margin1">技力：</li>
      <li class="li2 margin1">{{ child_effect['msp'] }}</li>
      <li class="li_k3">门派：</li>
      <li class="li3">{{ child.school }}</li>
      <li class="li_k2">资质：</li>
      <li class="li2">{{ child.potential }}</li>
      <li class="li_k3">武学：</li>
      <li class="li3">{{ child.kongfu }}</li>
      <li class="li_k2">学识：</li>
      <li class="li2">{{ child.knowledge }}</li>
      <li class="li_k3">统帅：</li>
      <li class="li3">{{ child.commander }}</li>
      <li class="li_k2">潜能：</li>
      <li class="li2">{{ child.unpoint }}</li>
      <li class="li_k3">快乐度：</li>
      <li class="li3 kaile">{{ child.intimacy }}</li>
      <li class="li_k2">加护：</li>
      <li class="li2">
        {{ child.enh }}
      </li>
    </ul>

    <p class="setctionTitle mt-15">神启</p>

    <ul class="DataListStyle clear">
      <li class="li_k3">登神境界：</li>
      <li class="li1 auto">
        {{ one_child.format_child?.['fs_lv_CN'] || '' }}
      </li>
      <li class="li_k3">灵破：</li>
      <li class="li3">
        {{ fsattr_props['lingpo'] }}
      </li>
      <li class="li_k2">灵御：</li>
      <li class="li2">
        {{ fsattr_props['lingyu'] }}
      </li>
      <li class="li_k3">灵钧：</li>
      <li class="li3">
        {{ fsattr_props['lingjun'] }}
      </li>
      <li class="li_k2">灵壁：</li>
      <li class="li2">
        {{ fsattr_props['lingbi'] }}
      </li>
      <li class="li_k3">破甲：</li>
      <li class="li3">
        {{ fsattr_props['ignore_pdef'] }}
      </li>
      <li class="li_k2">透魔：</li>
      <li class="li2">
        {{ fsattr_props['ignore_mdef'] }}
      </li>
      <li class="li_k3">破阵：</li>
      <li class="li3">
        {{
          fsattr_props['absolutely_attack_without_modify']
        }}
      </li>
      <li class="li_k2">磐石：</li>
      <li class="li2">
        {{
          fsattr_props[
            'absolutely_defence_without_modify'
          ]
        }}
      </li>
      <li class="li_k3">玄灵参悟：</li>
      <li class="li1 auto">
        {{ child.fspoint }}
      </li>
    </ul>
  </div>
</template>

<script setup>
import { defineProps, ref, computed } from 'vue';

const {
  child_tskill_img,
  child_pskill_img,
  child_sex_img,
  item_img,
  child_wing_img,
} = inject('filters');

const props = defineProps({
  one_child: {
    type: Object,
    default: () => ({}),
  },
});

const child = computed(() => {
  return props.one_child?.child || {};
})

const fsattr_props = computed(() => {
  return props.one_child?.child?.fsattr_props || {};
})

const child_effect = computed(() => {
  return props.one_child?.child?.child_effect || {};
})
</script>
